export default __webpack_public_path__ + "static/media/carauction.49f0d48a.png";